import { Stack } from '@mui/material'
import { useEffect } from 'react'
import { LoadingContainer } from '@/components/feedbacks/LoadingContainer'
import { SearchBar } from '@/features/search/SearchBar/SearchBar'
import { useFilterOptionsQuery, useLazyParseSearchStringQuery } from './api'
import { useSearch } from './hooks/useSearch'
import { SearchResults } from './SearchResults/SearchResults'

export const SearchPage = () => {
  const { setNext, applyNextSearch } = useSearch()
  const [parse, parseRequest] = useLazyParseSearchStringQuery()
  useFilterOptionsQuery()

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const criteriaString = searchParams.get('Criteria')
    if (!criteriaString) return

    parse(criteriaString)
      .unwrap()
      .then((searchObj) => {
        setNext(searchObj)
        applyNextSearch()
      })
      .catch((error) => {
        console.error('Failed to parse Criteria from URL', error)
      })
  }, [applyNextSearch, parse, setNext])

  return (
    <LoadingContainer loading={parseRequest.isFetching}>
      <Stack flexShrink={1} flexGrow={1} height="100%">
        <SearchBar />
        <SearchResults />
      </Stack>
    </LoadingContainer>
  )
}
